import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Instagram, Facebook, Menu, X } from "lucide-react";
import { siteData } from "../mock";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_layout-109/artifacts/1xqs2zrn_Logo%20Macaron%20fond%20transparent.png";

const NAV_LINKS = [
  { label: "Le Shiatsu", href: "#le-shiatsu" },
  { label: "Votre praticienne", href: "#praticienne" },
  { label: "Pour les entreprises", href: "#qvct" },
  { label: "Contact", href: "#contact" },
  { label: "Tarifs", href: "#tarifs" },
  { label: "Cartes cadeaux", href: "#cartes-cadeaux" },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const handleAnchor = (e, href) => {
    e.preventDefault();
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/" + href);
      return;
    }
    const id = href.replace("#", "");
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  // If we arrive on home with a hash, scroll to that section
  useEffect(() => {
    if (location.pathname === "/" && location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 120);
    }
  }, [location]);

  return (
    <header className={`site-header ${scrolled ? "is-scrolled" : ""}`}>
      <Link to="/" className="brand" aria-label="Accueil Catherine' Shiatsu">
        <img src={LOGO_URL} alt="Catherine' Shiatsu" className="brand-logo" />
      </Link>

      <nav className="nav-menu" aria-label="Menu principal">
        {NAV_LINKS.map((l) =>
          l.isRoute ? (
            <Link key={l.href} to={l.href} className="nav-link">
              {l.label}
            </Link>
          ) : (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => handleAnchor(e, l.href)}
              className="nav-link"
            >
              {l.label}
            </a>
          )
        )}
      </nav>

      <div className="header-actions">
        <a
          href="#contact"
          className="btn btn-primary"
          onClick={(e) => handleAnchor(e, "#contact")}
        >
          CONTACT
        </a>
        <a
          href={siteData.contact.facebookUrl}
          className="icon-btn"
          aria-label="Facebook"
          target="_blank"
          rel="noreferrer"
        >
          <Facebook size={20} strokeWidth={1.6} />
        </a>
        <a
          href={siteData.contact.instagramUrl}
          className="icon-btn"
          aria-label="Instagram"
          target="_blank"
          rel="noreferrer"
        >
          <Instagram size={20} strokeWidth={1.6} />
        </a>
        <button
          className="icon-btn menu-toggle"
          aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} strokeWidth={1.6} /> : <Menu size={22} strokeWidth={1.6} />}
        </button>
      </div>

      <div className={`mobile-menu ${open ? "is-open" : ""}`}>
        {NAV_LINKS.map((l) =>
          l.isRoute ? (
            <Link key={l.href} to={l.href} className="mobile-link" onClick={() => setOpen(false)}>
              {l.label}
            </Link>
          ) : (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => handleAnchor(e, l.href)}
              className="mobile-link"
            >
              {l.label}
            </a>
          )
        )}
      </div>
    </header>
  );
};

export default Header;
